import React from "react";
import "./ticketDetail.style.tsx";
import { Grid } from '@mui/material';
import { NOT_APPLICABLE } from '../../../constants/originalState';

export interface IRegisterDevice {
  infoTicket: {
    variables: {
      json_storage: {
        device_serial_number: string;
        device_manufacturer: string;
        device_model_name: string;
        comments: string;
      };
    };
  };
  locale: any;
}

const RegisterDevice: React.FC<IRegisterDevice> = (props) => {
  const { infoTicket, locale } = props;
  const json_storage = infoTicket?.variables?.json_storage;

  return (
    <Grid container>
      <Grid item xs={6} className="pr-20">
        <p className="ttl-col-desc">{locale?.deviceInfomation}</p>
        <p className="value-info" id="lbl-registerdevice-device_serial_number">
          <strong>{locale?.serialNumber}:</strong> {json_storage?.device_serial_number || NOT_APPLICABLE}
        </p>
        <p className="value-info" id="lbl-registerdevice-device_manufacturer">
          <strong>{locale?.manufacturer}:</strong> {json_storage?.device_manufacturer || NOT_APPLICABLE}
        </p>
        <p className="value-info" id="lbl-registerdevice-device_model_name">
          <strong>{locale?.modelName}:</strong> {json_storage?.device_model_name || NOT_APPLICABLE}
        </p>
      </Grid>
      <Grid item xs={12}>
        <p className="ttl-col-desc">{locale?.comments}</p>
        <p className="value-info value-comment" id="lbl-registerdevice-comments">{json_storage?.comments || NOT_APPLICABLE}</p>
      </Grid>
    </Grid>
  );
};

export default RegisterDevice;